namespace $.$$ {
	export class $shm_hitalama_components_history extends $.$shm_hitalama_components_history {
		rows() { return this.versions().entries().length ? this.versions().entries().map( entry => this.Entry( entry.link().str ) ) : [ this.Empty() ] }
		archive_visible() { return this.versions().archived_entries().length ? super.archive_visible() : [] }
		archive_rows() { return this.versions().archived_entries().map( entry => this.Entry( entry.link().str ) ) }
		entry_arg( id: string ) { return { application_version: id } }
		entry_title( id: string ) {
			const info = [ ...this.versions().entries(), ...this.versions().archived_entries() ].find( entry => entry.link().str === id )!.info()!
			const note = info.note.replace( /\s+/g, ' ' )
			const conflict = this.versions().entries().filter( entry => entry.info()!.version === info.version ).length > 1
			return `v${ info.version } (${ this.$.$shm_date.text( info.date.slice( 0, 10 ) ) })${ conflict ? ' — совпадающий номер' : '' }${ note ? ' — ' + note.slice( 0, 180 ) + ( note.length > 180 ? '…' : '' ) : '' }`
		}
	}
}
